export const mock=[
    {
        id:1,
        title:"Actual Premium",
        cost:"000.00"
    },
    {
        id:2,
        title:"Paid Premium",
        cost:"000.00"
    },
    {
        id:3,
        title:"Balance Premium",
        cost:"000.00"
    },
    {
        id:4,
        title:"Other Charges",
        cost:"000.00"
    },
    {
        id:5,
        title:"Total Taxes",
        cost:"000.00"
    }
]